
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 227.406 227.406"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 227.406 227.406","style":"enable-background:new 0 0 227.406 227.406;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M217.575,214.708l-65.188-67.793c16.139-15.55,26.209-37.356,26.209-61.485\r\n\t\tC178.596,38.323,140.272,0,93.167,0C46.06,0,7.737,38.323,7.737,85.43c0,47.106,38.323,85.43,85.43,85.43\r\n\t\tc17.574,0,33.922-5.339,47.518-14.473l66.078,68.718c1.473,1.531,3.439,2.302,5.407,2.302c1.87,0,3.743-0.695,5.197-2.094\r\n\t\tC220.353,222.441,220.446,217.693,217.575,214.708z M22.737,85.43c0-38.835,31.595-70.43,70.43-70.43\r\n\t\tc38.835,0,70.429,31.595,70.429,70.43s-31.594,70.43-70.429,70.43C54.332,155.859,22.737,124.265,22.737,85.43z"}}),_c('path',{attrs:{"d":"M131.414,77.93H54.919c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h76.495\r\n\t\tc4.143,0,7.5-3.357,7.5-7.5S135.557,77.93,131.414,77.93z"}})]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')])
          )
        }
      }
    